'use client';

import { isValidElement } from 'react';

import { atId, cn } from '../../utils';
import AlertTriangle from '../../assets/icons/AlertTriangle';

import Layout from './layout';

type AgeLimitProps = {
  headerTextProps?: {
    text?: string;
    componentProps?: React.ComponentProps<'span'>;
  };
  subTitleTextProps?: {
    text?: string;
    componentProps?: React.ComponentProps<'span'>;
  };
  logoProps?: React.ReactNode | React.ComponentProps<'svg'>;
  layoutProps?: Omit<React.ComponentProps<typeof Layout>, 'children'>;
};

const DEFAULT_SVG_SIZE = 80;

export default function AgeLimit(props: AgeLimitProps) {
  return (
    <Layout
      {...(props.layoutProps || {})}
      contentContainerClassName={cn(
        'flex flex-col items-center justify-center p-10 text-center text-neutral-100',
        props.layoutProps?.contentContainerClassName,
      )}
    >
      {isValidElement(props.logoProps) ? (
        props.logoProps
      ) : (
        <AlertTriangle
          width={DEFAULT_SVG_SIZE}
          height={DEFAULT_SVG_SIZE}
          {...(props.logoProps as React.ComponentProps<'svg'>)}
          className={cn(
            'fill-neutral-100',
            (props.logoProps as React.ComponentProps<'svg'> | undefined)?.className,
          )}
        />
      )}

      <span
        data-test-id={atId('ageGateLimitTitle', 'Val')}
        {...(props.headerTextProps?.componentProps ?? {})}
        className={cn(
          'mb-3 mt-4 font-headline-s text-headline-s',
          props.headerTextProps?.componentProps?.className,
        )}
      >
        {props.headerTextProps?.text || 'Age limit.'}
      </span>

      <span
        data-test-id={atId('ageGateLimitSubtitle', 'Val')}
        {...(props.subTitleTextProps?.componentProps ?? {})}
        className={cn(
          'font-body-m text-body-m',
          props.subTitleTextProps?.componentProps?.className,
        )}
      >
        {props.subTitleTextProps?.text || 'You must be older than 18 years to use this website.'}
      </span>
    </Layout>
  );
}
